import type { CSSProperties } from 'react';
import styles from './ProgressBar.module.css';

export interface ProgressBarProps {
  /** 0–100. */
  value: number;
  label: string;
  /** `alarm` shifts colour along the alarm ramp and pulses past 75 %; `blueprint` is the loading look. */
  tone?: 'default' | 'alarm' | 'blueprint';
  /** Shows the numeric value inside the bar. */
  showValue?: boolean;
}

export function ProgressBar({
  value,
  label,
  tone = 'default',
  showValue = false,
}: ProgressBarProps) {
  const pct = Math.min(100, Math.max(0, value));
  const stage = tone !== 'alarm' ? '' : pct >= 75 ? styles['hot'] : pct >= 50 ? styles['warm'] : '';
  return (
    <div
      className={[styles['bar'], styles[tone], stage ?? ''].filter(Boolean).join(' ')}
      role="progressbar"
      aria-label={label}
      aria-valuemin={0}
      aria-valuemax={100}
      aria-valuenow={Math.round(pct)}
    >
      <div className={styles['fill']} style={{ '--pct': `${pct}%` } as CSSProperties} />
      {showValue ? <span className={styles['value']}>{`${Math.round(pct)}%`}</span> : null}
    </div>
  );
}
